import React from 'react'
import { Breadcrumb } from 'react-bootstrap'
import DataTable from './DataTable/Table'
import Graybg from '../../UI/Graybg'
import SecBTN from '../../UI/SecBTN'
import { Link } from 'react-router-dom'
import classes from './UserList.module.css'

const UserList = () => {
  return (
    <div className='section'>
        <div className="d-flex justify-content-between align-items-center">
        <div>
        <h4>User's List</h4>
        <Breadcrumb>
        {/*<Breadcrumb.Item><Link to='/'> Home </Link></Breadcrumb.Item>*/}
        <Breadcrumb.Item active>User's List</Breadcrumb.Item>
      </Breadcrumb>
        </div>
        <Link to="/userList/addUser/"><SecBTN className={classes["sec-btn"]}>Add User</SecBTN></Link>
        </div>
      <Graybg>
      <DataTable/>
      </Graybg>
    </div>
  )
}

export default UserList


